<template>
  <div class="entity-main-data">
    <div class="item">
      <span class="title">Fecha</span>
      <span>{{ payment.dueDate }}</span>
    </div>
    <div class="item">
      <span class="title">Pago Nro.</span>
      <span>{{ payment.paymentNumber }}</span>
    </div>
    <div class="item">
      <span class="title">Monto</span>
      <span>UF {{ formatNumber(payment.monthlyPayment) }}</span>
    </div>
    <div class="item">
      <div v-if="showPayment" :id="`item-tag-${pos}`" class="movement-type field is-grouped item">
        <span v-if="payment.isPaid " id="payment-paid-tag" class="tag is-medium is-success is-light">
          PAGADO
        </span>
        <span v-else id="payment-not-paid-tag" class="tag is-medium is-danger is-light">
          NO PAGADO
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from '@/infrastructure/format';

export default {
  name: 'OperationPaymentDetail',
  props: {
    showPayment: {
      type: Boolean,
      default: false,
      required: false
    },
    operationId: {
      type: String,
      default: '',
      required: true
    },
    payment: {
      type: Object,
      default: () => {},
      required: true
    },
    pos: {
      type: Number,
      required: true
    }
  },
  data() {
    return { };
  },
  methods: {
    formatNumber: number => formatNumber({ number })
  }
};
</script>

<style scoped>
.error-message {
  justify-items: center;
  color: red;
}
.entity-main-data {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
}
.entity-main-data .item {
  display: grid;
  justify-content: stretch;
  margin: 0;
  margin-bottom: .5rem;
}
.entity-main-data .item .title {
  font-size: 0.8rem;
  margin: 0;
}
@media (max-width: 640px) {
  .entity-main-data .item {
    display: block;
    justify-content: stretch;
    margin-bottom: 10px;
  }
  .entity-main-data .item > span {
    margin-left: 5px;
  }
}
</style>
